import PropTypes from "prop-types";
import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import HomeIcon from "@material-ui/icons/Home";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import DescriptionIcon from "@material-ui/icons/Description";
import MessageIcon from "@material-ui/icons/Message";
import { withRouter } from "react-router";

import "./style.css";

class NavDrawer extends React.Component {
  onHomeClick = () => {
    this.props.history.push("/home");
  };

  onImagePortalClick = () => {
    this.props.history.push("/image-portal");
  };

  render() {
    console.log("[NAVDRAWER] RENDER");
    return (
      <div>
        <Drawer
          variant="permanent"
          open
          PaperProps={{ style: { borderRight: "none" } }}
        >
          <div style={{ width: "250px", height: "100vh", overflow: "hidden" }}>
            <div
              style={{
                padding: "16px 20px",
                background: "#Df1436",
                color: "#fff",
                borderBottom: "1px solid #e53935"
              }}
            >
              <Typography
                variant="h5"
                color="inherit"
                style={{ textAlign: "center", fontWeight: "bold" }}
              >
                STRUCTUBE
              </Typography>
            </div>
            <div style={{ height: "100%", background: "#Df1436" }}>
              <Typography
                variant="h6"
                style={{ padding: "20px 25px 0", color: "#fff" }}
              >
                Supplier Portal
              </Typography>
              <List style={{ color: "#fff", overflowY: "auto" }}>
                <ListItem button onClick={this.onHomeClick}>
                  <ListItemIcon>
                    <HomeIcon style={{ color: "#fff" }} />
                  </ListItemIcon>
                  <ListItemText primary="Home" />
                </ListItem>
                <ListItem button onClick={this.onImagePortalClick}>
                  <ListItemIcon>
                    <PhotoLibraryIcon style={{ color: "#fff" }} />
                  </ListItemIcon>
                  <ListItemText primary="Images" />
                </ListItem>
                <ListItem button disabled>
                  <ListItemIcon>
                    <DescriptionIcon style={{ color: "#fff" }} />
                  </ListItemIcon>
                  <ListItemText primary="Purchase Orders" />
                </ListItem>
                <ListItem button disabled>
                  <ListItemIcon>
                    <MessageIcon style={{ color: "#fff" }} />
                  </ListItemIcon>
                  <ListItemText primary="Messages" />
                </ListItem>
              </List>
            </div>
            <div
              style={{
                width: "210px",
                padding: "16px 20px",
                background: "#Df1436",
                color: "#fff",
                position: "absolute",
                bottom: "0",
                borderTop: "1px solid #e53935"
              }}
            >
              SUPPLIER <br />
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

NavDrawer.propTypes = {
  history: PropTypes.object
};

export default withRouter(NavDrawer);
